import styles from './dataSection.module.scss'

interface Props {
	title?: string | React.ReactNode
	titleSize?: 'tiny' | 'small' | 'medium' | 'large' | 'giant'
	topDesc?: string | React.ReactNode
	typeStr?: string | React.ReactNode
	titleDesc?: string | React.ReactNode
	children?: JSX.Element
	noPadding?: boolean
	titleStyle?: React.CSSProperties
	className?: string
}
const DataSection = ({
	title,
	topDesc,
	typeStr,
	titleDesc,
	children,
	titleSize = 'medium',
	noPadding,
	titleStyle,
	className,
}: Props) => {
	return (
		<div
			className={`${styles['data-section-wrap']} ${styles[noPadding ? 'no-padding' : '']} ${className ? className : ''}`}
		>
			{title && (
				<div
					className={`${styles['data-section-top']} ${styles[titleSize]}`}
					style={titleStyle ? titleStyle : {}}
				>
					<div
						className={`${styles['data-title-wrap']} ${topDesc ? styles['has-top-desc'] : ''}`}
					>
						<h2 className={styles['data-title']}>{title}</h2>
						{typeStr && (
							<div className={styles['section-type-str']}>
								<span>*</span>
								{typeStr}
							</div>
						)}
						{titleDesc && (
							<div className={styles['data-title-desc']}>{titleDesc}</div>
						)}
					</div>
					{topDesc && <div className={styles['data-top-desc']}>{topDesc}</div>}
				</div>
			)}
			{children && (
				<div className={styles['data-content-wrap']}>{children}</div>
			)}
		</div>
	)
}

export default DataSection
